import Layout from "../../layout.tsx/app";
import AssessmentPlace from "./places";
import AsesmenRegional from "./regional";

const ManageAsesmenIndex = () => {
  return (
    <Layout
      withPageTitle
      title="Manajemen Asesmen Offline"
      pageTitleContent={<div className="flex items-center"></div>}
    >
      <div className="md:grid md:grid-cols-3 gap-4">
        <div className="">
          <AsesmenRegional />
        </div>
        <div className="md:col-span-2">
          <div className="-mt-5">
            <AssessmentPlace />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ManageAsesmenIndex;
